import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function QuizLogistiek() {
  const { t } = useTranslation();
  const [answers, setAnswers] = useState<{[key: number]: string}>({});
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);

  const questions = [
    {
      id: 1,
      question: t('quiz_logistiek_q1'),
      options: {
        A: t('quiz_logistiek_q1_a'),
        B: t('quiz_logistiek_q1_b'),
        C: t('quiz_logistiek_q1_c')
      },
      correct: "B"
    },
    {
      id: 2,
      question: t('quiz_logistiek_q2'),
      options: {
        A: t('quiz_logistiek_q2_a'),
        B: t('quiz_logistiek_q2_b'),
        C: t('quiz_logistiek_q2_c')
      },
      correct: "A"
    },
    {
      id: 3,
      question: t('quiz_logistiek_q3'),
      options: {
        A: t('quiz_logistiek_q3_a'),
        B: t('quiz_logistiek_q3_b'),
        C: t('quiz_logistiek_q3_c')
      },
      correct: "C"
    },
    {
      id: 4,
      question: t('quiz_logistiek_q4'),
      options: {
        A: t('quiz_logistiek_q4_a'),
        B: t('quiz_logistiek_q4_b'),
        C: t('quiz_logistiek_q4_c')
      },
      correct: "B"
    },
    {
      id: 5,
      question: t('quiz_logistiek_q5'),
      options: {
        A: t('quiz_logistiek_q5_a'),
        B: t('quiz_logistiek_q5_b'),
        C: t('quiz_logistiek_q5_c')
      },
      correct: "A"
    },
    {
      id: 6,
      question: t('quiz_logistiek_q6'),
      options: {
        A: t('quiz_logistiek_q6_a'),
        B: t('quiz_logistiek_q6_b'),
        C: t('quiz_logistiek_q6_c')
      },
      correct: "C"
    },
    {
      id: 7,
      question: t('quiz_logistiek_q7'),
      options: {
        A: t('quiz_logistiek_q7_a'),
        B: t('quiz_logistiek_q7_b'),
        C: t('quiz_logistiek_q7_c')
      },
      correct: "B"
    },
    {
      id: 8,
      question: t('quiz_logistiek_q8'),
      options: {
        A: t('quiz_logistiek_q8_a'),
        B: t('quiz_logistiek_q8_b'),
        C: t('quiz_logistiek_q8_c')
      },
      correct: "A"
    },
    {
      id: 9,
      question: t('quiz_logistiek_q9'),
      options: {
        A: t('quiz_logistiek_q9_a'),
        B: t('quiz_logistiek_q9_b'),
        C: t('quiz_logistiek_q9_c')
      },
      correct: "C"
    },
    {
      id: 10,
      question: t('quiz_logistiek_q10'),
      options: {
        A: t('quiz_logistiek_q10_a'),
        B: t('quiz_logistiek_q10_b'),
        C: t('quiz_logistiek_q10_c')
      },
      correct: "B"
    },
    {
      id: 11,
      question: t('quiz_logistiek_q11'),
      options: {
        A: t('quiz_logistiek_q11_a'),
        B: t('quiz_logistiek_q11_b'),
        C: t('quiz_logistiek_q11_c')
      },
      correct: "A"
    },
    {
      id: 12,
      question: t('quiz_logistiek_q12'),
      options: {
        A: t('quiz_logistiek_q12_a'),
        B: t('quiz_logistiek_q12_b'),
        C: t('quiz_logistiek_q12_c')
      },
      correct: "C"
    },
    {
      id: 13,
      question: t('quiz_logistiek_q13'),
      options: {
        A: t('quiz_logistiek_q13_a'),
        B: t('quiz_logistiek_q13_b'),
        C: t('quiz_logistiek_q13_c')
      },
      correct: "B"
    },
    {
      id: 14,
      question: t('quiz_logistiek_q14'),
      options: {
        A: t('quiz_logistiek_q14_a'),
        B: t('quiz_logistiek_q14_b'),
        C: t('quiz_logistiek_q14_c')
      },
      correct: "A"
    },
    {
      id: 15,
      question: t('quiz_logistiek_q15'),
      options: {
        A: t('quiz_logistiek_q15_a'),
        B: t('quiz_logistiek_q15_b'),
        C: t('quiz_logistiek_q15_c')
      },
      correct: "C"
    },
    {
      id: 16,
      question: t('quiz_logistiek_q16'),
      options: {
        A: t('quiz_logistiek_q16_a'),
        B: t('quiz_logistiek_q16_b'),
        C: t('quiz_logistiek_q16_c')
      },
      correct: "B"
    },
    {
      id: 17,
      question: t('quiz_logistiek_q17'),
      options: {
        A: t('quiz_logistiek_q17_a'),
        B: t('quiz_logistiek_q17_b'),
        C: t('quiz_logistiek_q17_c')
      },
      correct: "A"
    },
    {
      id: 18,
      question: t('quiz_logistiek_q18'),
      options: {
        A: t('quiz_logistiek_q18_a'),
        B: t('quiz_logistiek_q18_b'),
        C: t('quiz_logistiek_q18_c')
      },
      correct: "C"
    },
    {
      id: 19,
      question: t('quiz_logistiek_q19'),
      options: {
        A: t('quiz_logistiek_q19_a'),
        B: t('quiz_logistiek_q19_b'),
        C: t('quiz_logistiek_q19_c')
      },
      correct: "B"
    },
    {
      id: 20,
      question: t('quiz_logistiek_q20'),
      options: {
        A: t('quiz_logistiek_q20_a'),
        B: t('quiz_logistiek_q20_b'),
        C: t('quiz_logistiek_q20_c')
      },
      correct: "A"
    },
    {
      id: 21,
      question: t('quiz_logistiek_q21'),
      options: {
        A: t('quiz_logistiek_q21_a'),
        B: t('quiz_logistiek_q21_b'),
        C: t('quiz_logistiek_q21_c')
      },
      correct: "C"
    },
    {
      id: 22,
      question: t('quiz_logistiek_q22'),
      options: {
        A: t('quiz_logistiek_q22_a'),
        B: t('quiz_logistiek_q22_b'),
        C: t('quiz_logistiek_q22_c')
      },
      correct: "B"
    },
    {
      id: 23,
      question: t('quiz_logistiek_q23'),
      options: {
        A: t('quiz_logistiek_q23_a'),
        B: t('quiz_logistiek_q23_b'),
        C: t('quiz_logistiek_q23_c')
      },
      correct: "A"
    },
    {
      id: 24,
      question: t('quiz_logistiek_q24'),
      options: {
        A: t('quiz_logistiek_q24_a'),
        B: t('quiz_logistiek_q24_b'),
        C: t('quiz_logistiek_q24_c')
      },
      correct: "C"
    },
    {
      id: 25,
      question: t('quiz_logistiek_q25'),
      options: {
        A: t('quiz_logistiek_q25_a'),
        B: t('quiz_logistiek_q25_b'),
        C: t('quiz_logistiek_q25_c')
      },
      correct: "B"
    },
    {
      id: 26,
      question: t('quiz_logistiek_q26'),
      options: {
        A: t('quiz_logistiek_q26_a'),
        B: t('quiz_logistiek_q26_b'),
        C: t('quiz_logistiek_q26_c')
      },
      correct: "A"
    },
    {
      id: 27,
      question: t('quiz_logistiek_q27'),
      options: {
        A: t('quiz_logistiek_q27_a'),
        B: t('quiz_logistiek_q27_b'),
        C: t('quiz_logistiek_q27_c')
      },
      correct: "C"
    },
    {
      id: 28,
      question: t('quiz_logistiek_q28'),
      options: {
        A: t('quiz_logistiek_q28_a'),
        B: t('quiz_logistiek_q28_b'),
        C: t('quiz_logistiek_q28_c')
      },
      correct: "B"
    },
    {
      id: 29,
      question: t('quiz_logistiek_q29'),
      options: {
        A: t('quiz_logistiek_q29_a'),
        B: t('quiz_logistiek_q29_b'),
        C: t('quiz_logistiek_q29_c')
      },
      correct: "A"
    },
    {
      id: 30,
      question: t('quiz_logistiek_q30'),
      options: {
        A: t('quiz_logistiek_q30_a'),
        B: t('quiz_logistiek_q30_b'),
        C: t('quiz_logistiek_q30_c')
      },
      correct: "C"
    }
  ];

  const handleAnswerChange = (questionId: number, answer: string) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: answer
    }));
  };

  const calculateScore = () => {
    let correctAnswers = 0;
    questions.forEach(question => {
      if (answers[question.id] === question.correct) {
        correctAnswers++;
      }
    });
    setScore(correctAnswers);
    setShowResults(true);
  };

  const resetQuiz = () => {
    setAnswers({});
    setShowResults(false);
    setScore(0);
  };

  const getFeedback = () => {
    const percentage = (score / questions.length) * 100;
    if (percentage >= 85) return t('quiz_excellent');
    if (percentage >= 70) return t('quiz_good');
    if (percentage >= 55) return t('quiz_average');
    return t('quiz_review');
  };

  const getScoreColor = () => {
    const percentage = (score / questions.length) * 100;
    if (percentage >= 85) return 'text-green-600';
    if (percentage >= 70) return 'text-blue-600';
    if (percentage >= 55) return 'text-yellow-600';
    return 'text-red-600';
  };

  const getScoreBgColor = () => {
    const percentage = (score / questions.length) * 100;
    if (percentage >= 85) return 'bg-green-100';
    if (percentage >= 70) return 'bg-blue-100';
    if (percentage >= 55) return 'bg-yellow-100';
    return 'bg-red-100';
  };

  return (
    <Layout>
      <div className="max-w-5xl mx-auto space-y-8">
        <div className="text-center mb-12">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center">
            <i className="ri-questionnaire-line text-6xl text-indigo-600"></i>
          </div>
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('quiz_logistiek_title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('quiz_logistiek_intro')}
          </p>
          <div className="mt-6 p-4 bg-indigo-50 rounded-lg">
            <p className="text-indigo-800 font-medium">
              {t('quiz_logistiek_instructions')}
            </p>
          </div>
        </div>

        {!showResults ? (
          <div className="space-y-8">
            {questions.map((question, index) => (
              <div key={question.id} className="bg-white rounded-xl p-6 shadow-lg border border-gray-100">
                <h3 className="text-lg font-semibold mb-6 text-gray-800">
                  <span className="inline-flex items-center justify-center w-8 h-8 bg-indigo-600 text-white rounded-full text-sm font-bold mr-3">
                    {index + 1}
                  </span>
                  {question.question}
                </h3>
                <div className="space-y-4 ml-11">
                  {Object.entries(question.options).map(([key, value]) => (
                    <label key={key} className="flex items-start space-x-4 cursor-pointer hover:bg-gray-50 p-4 rounded-lg transition-colors group">
                      <input
                        type="radio"
                        name={`question-${question.id}`}
                        value={key}
                        checked={answers[question.id] === key}
                        onChange={() => handleAnswerChange(question.id, key)}
                        className="w-5 h-5 text-indigo-600 mt-0.5 flex-shrink-0"
                      />
                      <div className="flex items-start space-x-3">
                        <span className="font-bold text-indigo-600 text-lg">{key}.</span>
                        <span className="text-gray-700 group-hover:text-gray-900">{value}</span>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            ))}

            <div className="text-center py-8">
              <div className="mb-4">
                <p className="text-gray-600 mb-2">
                  {t('quiz_progress')}: {Object.keys(answers).length} / {questions.length}
                </p>
                <div className="w-full bg-gray-200 rounded-full h-3 max-w-md mx-auto">
                  <div 
                    className="bg-indigo-600 h-3 rounded-full transition-all duration-300"
                    style={{ width: `${(Object.keys(answers).length / questions.length) * 100}%` }}
                  ></div>
                </div>
              </div>
              <button
                onClick={calculateScore}
                disabled={Object.keys(answers).length < questions.length}
                className="bg-indigo-600 text-white px-10 py-4 rounded-lg font-semibold hover:bg-indigo-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap text-lg"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2 inline-block">
                  <i className="ri-check-line"></i>
                </div>
                {t('quiz_submit')}
              </button>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <div className="text-center mb-8">
              <div className={`w-32 h-32 mx-auto rounded-full flex items-center justify-center mb-6 ${getScoreBgColor()}`}>
                <div className="text-center">
                  <span className={`text-4xl font-bold ${getScoreColor()}`}>
                    {score}
                  </span>
                  <div className={`text-lg ${getScoreColor()}`}>
                    / {questions.length}
                  </div>
                </div>
              </div>
              
              <h2 className="text-3xl font-bold mb-4 text-gray-800">{t('quiz_score')}</h2>
              
              <div className={`text-2xl font-semibold mb-4 ${getScoreColor()}`}>
                {Math.round((score / questions.length) * 100)}%
              </div>
              
              <p className={`text-xl mb-4 ${getScoreColor()}`}>
                {getFeedback()}
              </p>
              
              <p className="text-gray-600 text-lg">
                {score} {t('quiz_correct')} {questions.length} {t('quiz_questions')}
              </p>

              {score >= 26 && (
                <div className="mt-8 p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg">
                  <div className="w-20 h-20 mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-trophy-line text-6xl text-yellow-500"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-green-800 mb-2">
                    🎉 {t('quiz_expert_level')} 🎉
                  </h3>
                  <p className="text-green-700">
                    {t('quiz_expert_message')}
                  </p>
                </div>
              )}
            </div>

            <div className="flex justify-center space-x-6 mt-8">
              <button
                onClick={resetQuiz}
                className="bg-gray-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors whitespace-nowrap"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2 inline-block">
                  <i className="ri-refresh-line"></i>
                </div>
                {t('quiz_retry')}
              </button>
              <Link
                to="/"
                className="bg-indigo-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-indigo-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                <div className="w-5 h-5 flex items-center justify-center mr-2 inline-block">
                  <i className="ri-home-line"></i>
                </div>
                {t('nav_home')}
              </Link>
            </div>
          </div>
        )}

        <div className="flex justify-between items-center pt-8">
          <Link 
            to="/onderhoudstechniek"
            className="flex items-center text-indigo-600 hover:text-indigo-700 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-arrow-left-line"></i>
            </div>
            {t('nav_maintenance')}
          </Link>
          <Link 
            to="/"
            className="flex items-center text-indigo-600 hover:text-indigo-700 cursor-pointer"
          >
            {t('nav_home')}
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-home-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
}